import { render, staticRenderFns } from "./ReturnBooking.vue?vue&type=template&id=90db1f5a&scoped=true"
import script from "./ReturnBooking.vue?vue&type=script&lang=js"
export * from "./ReturnBooking.vue?vue&type=script&lang=js"
import style0 from "./ReturnBooking.vue?vue&type=style&index=0&id=90db1f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90db1f5a",
  null
  
)

export default component.exports